import { SkeletonBox, SkeletonText } from "@ui/components/Skeleton";

function ConversationListItemSkeleton() {
  return (
    <div className="flex items-center gap-3 px-3 py-2.5">
      <SkeletonBox className="size-11 shrink-0" rounded="full" />
      <div className="flex flex-1 flex-col gap-1.5">
        <SkeletonText lines={2} />
      </div>
    </div>
  );
}

export function ConversationListSkeleton() {
  return (
    <div className="flex flex-col">
      <ConversationListItemSkeleton />
      <ConversationListItemSkeleton />
      <ConversationListItemSkeleton />
      <ConversationListItemSkeleton />
      <ConversationListItemSkeleton />
    </div>
  );
}
